// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import {
    getComponent,
    addUrlParams,
    prepareUrl,
    showInternalError,
    addStatusMessage,
    clearStatusMessages,
} from './common';

/**
 * @class Jsw.DoubleListSelector
 * @extends Jsw.Component
 */
export const DoubleListSelector = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);
        this._cls = 'doubleListSelect';
        this._name = this._getConfigParam('name', '');
        this._list = this._getConfigParam('list', $A());
        this._dataUrl = this._getConfigParam('dataUrl', null);
        this._selectedMarked = 0;
        this._unselectedMarked = 0;
        this._prevSelectedItem = -1;
        this._isSearchable = this._getConfigParam('isSearchable', false);
        this._isLarge = this._getConfigParam('isLarge', false);
    },

    _initList() {
        const elements = {};
        this._list.each(function (element, index) {
            element.marked = false;
            if ('undefined' === typeof element.selected) {
                element.selected = false;
            }

            this._initListItem(element, index, true);
            this._initListItem(element, index, false);
            elements[element.id] = element.selected;
        }, this);
        this._originalSelection = elements;
        this._initInputElement(elements);
    },

    _initComponentElement() {
        this._componentElement = $(this._applyTargetId);
        this._componentElement.addClassName('double-list-select');
        this._componentElement.addClassName('dls-icons-1');
        if (this._isLarge) {
            this._componentElement.addClassName('dls-large');
        }

        const searchControlUnselected = this._isSearchable ? this._getSearchControl('unselected') : '';
        const searchControlSelected = this._isSearchable ? this._getSearchControl('selected') : '';
        const ajaxLoading = null === this._dataUrl ? ''
            : `<div class="ajax-loading" style="display: none;">${this.lmsg('loadingTitle')}</div>`;

        const listHtml =
            `<div class="dls-first-box">${searchControlUnselected}` +
                `<h4><span>${this.lmsg('unselectedTitle')}</span></h4>` +
                `<div  id="${this._id}-container-unselected" class="dls-box-area">${ajaxLoading}<ul id="${this._id}-unselected"></ul></div>` +
            '</div>' +
            `<div class="dls-second-box">${searchControlSelected}` +
                `<h4><span>${this.lmsg('selectedTitle')}</span></h4>` +
                `<div id="${this._id}-container-selected" class="dls-box-area">${ajaxLoading}<ul id="${this._id}-selected"></ul></div>` +
            '</div>' +
            `<div id="${this._id}-controls" class="dls-controls">` +
                `<span id="${this._id}-controls-select" class="btn disabled">` +
                    `<button type="button" id="${this._id}-submitSelect" onclick="return false;"><span class="dls-add">&gt;&gt;</span></button>` +
                '</span>' +
                `<span id="${this._id}-controls-unselect" class="btn disabled">` +
                    `<button type="button" id="${this._id}-submitUnselect" onclick="return false;"><span class="dls-remove">&lt;&lt;</span></button>` +
                '</span>' +
            '</div>';

        this._updateComponentElement(listHtml);
        this._initList();
    },

    _initListItem(element, index, isSelected) {
        let container = null;
        let isHidden = false;
        if (isSelected) {
            container = $(`${this._id}-selected`);
            isHidden = !element.selected;
        } else {
            container = $(`${this._id}-unselected`);
            isHidden = element.selected;
        }

        const item = new Element('div', {
            class: 'dls-item-block',
        })
            .insert(`<b>${element.title.escapeHTML()}</b>`);

        if (element.description) {
            item.insert(`<span>${element.description}</span>`);
        }

        if (element.icons && element.icons.length) {
            const itemIcons = new Element('span', {
                class: 'dls-icons',
            });

            element.icons.each(function (icon) {
                itemIcons
                    .insert(`<i class="icon"><img src="${Jsw.skinUrl}${icon.src}" title="${icon.title}"></i>`);
            }, this);

            item.insert(itemIcons);
        }

        const listItem = new Element('li', {
            id: `${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`,
        })
            .insert(item);


        container.insert(listItem);
        const context = this;
        listItem.observe('click', function (event) {
            context._toggleItem(index, isSelected, event);
        });
        if (isHidden) {
            listItem.hide();
        }
    },

    _initInputElement(elements) {
        let inputElement = $(`${this._id}-elements`);
        if (!inputElement) {
            inputElement = new Element('input', {
                id: `${this._id}-elements`,
                name: this._name,
                type: 'hidden',
            });
            this._componentElement.insert(inputElement);
        }
        inputElement.setValue(JSON.stringify(elements));
    },

    _getSearchControl(columnId) {
        return '' +
            '<div class="dls-search">' +
                `<input id="${this._id}-search-${columnId}" class="search-input search-empty" type="text" autocomplete="off"` +
                    ` value="${this.lmsg('searchTitle')}"` +
                    ` onfocus="Jsw.getComponent('${this._id}').onFocus(this)"` +
                    ` onblur="Jsw.getComponent('${this._id}').onBlur(this)"` +
                    ` onkeyup="Jsw.getComponent('${this._id}').onToggleSearch('${columnId}', this.value);">` +
                `<span id="${this._id}-search-button-${columnId}" class="search-button icon-search"` +
                    ` onmousedown="Jsw.getComponent('${this._id}').onResetSearch('${columnId}');">` +
                '</span>' +
            '</div>';
    },

    _addEvents() {
        $(`${this._id}-controls-select`).observe('click', this._onSubmitSelect.bind(this));
        $(`${this._id}-controls-unselect`).observe('click', this._onSubmitUnselect.bind(this));
    },

    _toggleItem(index, isSelected, event) {
        if (this._list[index].marked) {
            this._unmarkItem(index, isSelected, event);
        } else {
            this._markItem(index, isSelected, event);
        }
    },

    _markItem(index, isSelected, event) {
        if (('undefined' !== typeof event) && event.shiftKey && (-1 !== this._prevSelectedItem)) {
            const startIndex = Math.min(index, this._prevSelectedItem);
            const finishIndex = Math.max(index, this._prevSelectedItem);
            for (let i = startIndex; i < finishIndex; i++) {
                this._markItem(i, isSelected);
            }
        }

        this._prevSelectedItem = index;

        this._list[index].marked = true;
        $(`${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`).addClassName('marked');
        this._updateSelectControls(isSelected, true);
    },

    _unmarkItem(index, isSelected, event) {
        this._list[index].marked = false;
        $(`${this._id}-${index}-${isSelected ? 'selected' : 'unselected'}-item`).removeClassName('marked');
        this._updateSelectControls(isSelected, false);
    },

    _onSubmitSelect() {
        this._list.each(function (element, index) {
            if (element.marked && !element.selected && $(`${this._id}-${index}-unselected-item`).visible()) {
                this._unmarkItem(index, false);
                element.selected = true;
                this._updateElement(element);
                $(`${this._id}-${index}-unselected-item`).hide();
                $(`${this._id}-${index}-selected-item`).show();
            }
        }, this);

        this.onChange();
    },

    _onSubmitUnselect() {
        this._list.each(function (element, index) {
            if (element.marked && element.selected && $(`${this._id}-${index}-selected-item`).visible()) {
                this._unmarkItem(index, true);
                element.selected = false;
                this._updateElement(element);
                $(`${this._id}-${index}-selected-item`).hide();
                $(`${this._id}-${index}-unselected-item`).show();
            }
        }, this);

        this.onChange();
    },

    _updateElement(element) {
        const elements = JSON.parse($(`${this._id}-elements`).value);
        elements[element.id] = element.selected;
        $(`${this._id}-elements`).value = JSON.stringify(elements);
    },

    onChange() {},

    onToggleSearch(columnId, searchString) {
        const isSelected = (columnId === 'selected');
        searchString = searchString.strip().toLowerCase();

        if (searchString.length) {
            this._toggleSearchButtonIcon(columnId, true);
            this._list.each(function (element, index) {
                if (isSelected !== element.selected) {
                    return;
                }
                const item = $(`${this._id}-${index}-${columnId}-item`);
                if (this._isSearchMatched(element, searchString)) {
                    if (!item.visible() && element.marked) {
                        this._updateSelectControls(isSelected, true);
                    }
                    item.show();
                } else {
                    if (item.visible() && element.marked) {
                        this._updateSelectControls(isSelected, false);
                    }
                    item.hide();
                }
            }, this);
        } else {
            this._toggleSearchButtonIcon(columnId, false);
            this._showAllItems(columnId);
        }
    },

    _isSearchMatched(element, searchString) {
        const searchIndex = 'undefined' === typeof element.searchIndex
            ? element.title
            : element.searchIndex;

        return -1 !== searchIndex.toLowerCase().indexOf(searchString);
    },

    onFocus(element) {
        if (this.lmsg('searchTitle') === element.value) {
            element.value = '';
            element.removeClassName('search-empty');
        }
    },

    onBlur(element) {
        if ('' === element.value) {
            this._resetSearchControl(element);
        }
    },

    onResetSearch(columnId) {
        this._showAllItems(columnId);
        const element = $(`${this._id}-search-${columnId}`);
        this._resetSearchControl(element);
        this._toggleSearchButtonIcon(columnId, false);
    },

    _showAllItems(columnId) {
        const isSelected = (columnId === 'selected');
        this._list.each(function (element, index) {
            if (isSelected === element.selected) {
                const item = $(`${this._id}-${index}-${columnId}-item`);
                if (!item.visible() && element.marked) {
                    this._updateSelectControls(isSelected, true);
                }
                item.show();
            }
        }, this);
    },

    _resetSearchControl(element) {
        element.value = this.lmsg('searchTitle');
        element.addClassName('search-empty');
    },

    _toggleSearchButtonIcon(columnId, isActive) {
        $(`${this._id}-search-button-${columnId}`).toggleClassName('search-button-clear', isActive);
    },

    _updateSelectControls(isSelected, setMarked) {
        let counter = isSelected ? this._selectedMarked : this._unselectedMarked;
        const controlId = isSelected ? 'unselect' : 'select';

        setMarked ? counter++ : counter--;
        $(`${this._id}-controls-${controlId}`).toggleClassName('disabled', !counter);

        if (isSelected) {
            this._selectedMarked = counter;
        } else {
            this._unselectedMarked = counter;
        }
    },

    isEmpty() {
        return !this._list.any(function (element) {
            return element.selected;
        });
    },

    reload(params) {
        if (!this._dataUrl) {
            return;
        }

        const reloadUrl = addUrlParams(this._dataUrl, params);
        new Ajax.Request(prepareUrl(reloadUrl), {
            method: 'get',
            onSuccess: this._onReloadSuccess.bind(this),
            onFailure: this._onReloadFailure.bind(this),
            onException: this._onReloadException.bind(this),
            onCreate: this._onReloadCreate.bind(this),
            onComplete: this._onReloadComplete.bind(this),
        });
    },

    _onReloadSuccess(transport) {
        if (!transport.responseText) {
            // :INFO: sometimes happens in FF if you are go to other page during request
            return;
        }

        let data = {};
        try {
            data = transport.responseText.evalJSON();
        } catch (e) {
            showInternalError(transport.responseText);
            return;
        }

        if (data.list) {
            this._list = $A(data.list);
        } else if (data.status) {
            clearStatusMessages();
            $A(data.statusMessages).each(function (message) {
                addStatusMessage(message.status, message.content);
            });
        } else {
            showInternalError('Unable to load list data.');
        }

        this._initList();
    },

    _onReloadFailure(transport) {
        showInternalError(transport.responseText);
    },

    _onReloadException(transport, exception) {
        showInternalError(`${exception}\n${transport.responseText}`);
    },

    _onReloadCreate(transport) {
        this._list = $A();
        this._componentElement.select('.dls-box-area').each(function (listArea) {
            listArea.select('ul').first().update();
            listArea.select('.ajax-loading').first().show();
        });
    },

    _onReloadComplete() {
        this._componentElement.select('.dls-box-area').each(function (listArea) {
            listArea.select('.ajax-loading').first().hide();
        });
    },

    reset() {
        this._list.forEach(function (item) {
            item.selected = this._originalSelection[item.id];
        }, this);

        const list = this._list;
        this._onReloadCreate();
        this._onReloadComplete();
        this._list = list;

        this._initList();
    },
});



// WEBPACK FOOTER //
// ./jsw/double-list-selector.js